import { SlidersHorizontal } from 'lucide-react'
import { TooltipProvider } from '@teach/ui'
import type { CourseWithoutBlocks } from '@/types/course'
import { UndoRedoButtons } from '../EditorHeader/UndoRedoButtons'
import { SoundToggleButton } from '../EditorHeader/SoundToggleButton'
import { QuickLangSwitch } from '../EditorHeader/QuickLangSwitch'
import { TooltipIconButton } from '../EditorHeader/TooltipIconButton'
import { DesignOverflowWarning } from './DesignOverflowWarning'
import { useMessages } from '@/i18n'
import { messages } from './messages'

interface Props {
  course: CourseWithoutBlocks
  /** Уже `lg`: открыть выезжающую панель экрана. `null` — открывать нечего. */
  onOpenPanel: (() => void) | null
}

/** Отменить / вернуть / звук и язык — плавающие инструменты холста на стеклянной
 *  подложке (с `lg`): холст (широкий экран видео) может заходить под них, а они
 *  остаются читаемыми. Уже `lg` на холсте их нет — они баром над уроками
 *  (`MobileTimelineBar`), и экран урока получает всю высоту холста; здесь остаётся
 *  только предупреждение дизайн-блока. */
export const CanvasTools = ({ course, onOpenPanel }: Props) => {
  const m = useMessages(messages)
  return (
    <TooltipProvider delayDuration={200}>
      <div className="absolute right-3 top-2 z-20 flex items-center gap-2 lg:bottom-3 lg:top-auto">
        {/* Предупреждение — отдельно, левее стекла: это сигнал про экран, а не
            инструмент в одном ряду с языком и отменой. */}
        <DesignOverflowWarning />
        {/* Уже `lg` эти инструменты — баром над уроками (`MobileTimelineBar`). */}
        <div className="hidden items-center gap-1 rounded-full border border-white/10 bg-background/40 p-1 shadow-lg backdrop-blur-xl backdrop-saturate-150 lg:flex">
          {onOpenPanel ? (
            <span className="contents lg:hidden">
              <TooltipIconButton
                icon={SlidersHorizontal}
                ariaLabel={m.openBlockPanel}
                onClick={onOpenPanel}
              />
            </span>
          ) : null}
          <QuickLangSwitch course={course} />
          <UndoRedoButtons />
          <SoundToggleButton />
        </div>
      </div>
    </TooltipProvider>
  )
}
